import * as React from 'react'
import StandardInput from '../components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../components/recaptcha'
import CheckboxInput from '../components/checkbox-input'
import StepTitle from '../components/step-title'
import SubHeader from '../components/sub-header'
import StepBlock from '../components/step-block'
import Button from '../components/button'
import QueryString from 'query-string'
import { condition, getQueryString } from '../../common/util'
import { withNavigation } from '../modules/navigation'
import { withRouteBlocker } from '../modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withConfig } from '../../common/modules/config'
import { withProductData } from '../../common/modules/product-data';


@withNavigation
@withRouteBlocker
@withScrollToTop
@withConfig
@withProductData
class PaymentResult extends React.Component<any, any>{


    componentDidMount(){
        const extracted = QueryString.extract(window.location.href);
        const parsed = QueryString.parse(extracted)
        const paymentSuccessful = this.props.fields.successful || parsed.successful=='true';

        if(paymentSuccessful){
            console.log("Disable close warning")
            this.props.actions.navigation.setCloseWarning(false);
        }
    }
    

    render(){
        const extracted = QueryString.extract(window.location.href);
        const parsed = QueryString.parse(extracted)

        const paymentSuccessful = this.props.fields.successful || parsed.successful=='true';
        const paymentFailReason = this.props.fields.reason || parsed.reason;
        const policyNumber = this.props.fields.policyNumber || parsed.policyNumber;

        return (
            <div className="row">
                <div className="col-12">
                    <StepTitle show={ paymentSuccessful }>Thank you</StepTitle>
                    <StepTitle show={ !paymentSuccessful }>Payment wasn't successful</StepTitle>

                    <StepBlock show={ !paymentSuccessful }  className="mt-4">
                        <h4>We are sorry but your payment could not be completed.</h4>
                        <br/>
                        <h4>{ paymentFailReason }</h4>
                        <br/>
                        {condition(
                            paymentFailReason != "The valid to date has expired." && paymentFailReason != "This quote cannot be bound due to an active embargo, please contact your CHU underwriter for assistance.",
                            <h4>Please try again with the options below. If you are still experiencing issues, please contact <strong>CHU</strong> directly on <strong>1300 201 021</strong>.</h4>
                        )}
                    </StepBlock>

                    <SubHeader show={ paymentSuccessful } className="mt-4">Your policy number is { policyNumber }</SubHeader>
                    <StepBlock show={ paymentSuccessful }>
                        <p>You will also receive a copy of your policy via email to the address you provided.</p>
                    </StepBlock>

                    {condition(
                        paymentFailReason != "The valid to date has expired." && paymentFailReason != "This quote cannot be bound due to an active embargo, please contact your CHU underwriter for assistance.",
                        <Button.PaymentButtons show={ !paymentSuccessful }/>
                    )}

                    <StepBlock show={ paymentSuccessful } className="mt-4">
                        <a href={ this.props.config.paymentSuccessRedirect } className="btn btn-primary btn-lg mt-2">Return Home</a>
                    </StepBlock>
                </div>
            </div>
        )
    }
}

export default PaymentResult;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/routes/payment-result.tsx